import { render, staticRenderFns } from "./VerifyChangedEmailForm.vue?vue&type=template&id=c45768c8&"
import script from "./VerifyChangedEmailForm.vue?vue&type=script&lang=js&"
export * from "./VerifyChangedEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./VerifyChangedEmailForm.vue?vue&type=style&index=0&id=c45768c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports